define("shared/components/shared/linkinbio/modal/upgrade", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @isVisible}}
    <Shared::Modal @close={{@closeModal}} as |modal|>
      <modal.card class="tOB--image__lib">
        <modal.card-body>
          <div class="u--row">
            {{! Description }}
            <div class="u--col__6 u--col__push--6 cLB--contentWidth">
              <modal.card-header class="u--p__b__xs">
                <p class="o--modalHeader__title u--text--lg">{{t "linkinbio.upgrade_modal.title"}}</p>
              </modal.card-header>
              <modal.card-body class="u--p__t__0">
                <p class="u--text--md u--m__b__lg">{{t "linkinbio.upgrade_modal.subtitle"}}</p>
                <ol class="u--listUnstyle u--m__b__lg u--m__r__md">
                  <li>
                    <h3 class="u--text--md u--text--bold u--m__b__xs">{{t "linkinbio.upgrade_modal.feature_1.title"}}</h3>
                    <p>{{t "linkinbio.upgrade_modal.feature_1.description"}}</p>
                  </li>
  
                  {{#unless @isOnLegacyPlan}}
                    <li>
                      <h3 class="u--text--md u--text--bold u--m__b__xs">{{t "linkinbio.upgrade_modal.feature_2.title"}}</h3>
                      <p>{{t "linkinbio.upgrade_modal.feature_2.description"}}</p>
                    </li>
                  {{/unless}}
  
                  <li>
                    <h3 class="u--text--md u--text--bold u--m__b__xs">{{t "linkinbio.upgrade_modal.feature_3.title"}}</h3>
                    <p>{{t "linkinbio.upgrade_modal.feature_3.description"}}</p>
                  </li>
  
                  <li>
                    <h3 class="u--text--md u--text--bold u--m__b__xs">{{t "linkinbio.upgrade_modal.feature_4.title"}}</h3>
                    <p>{{t "linkinbio.upgrade_modal.feature_4.description"}}</p>
                  </li>
  
                  <li>
                    <h3 class="u--text--md u--text--bold u--m__b__xs">{{t "linkinbio.upgrade_modal.feature_5.title"}}</h3>
                    <p>{{t "linkinbio.upgrade_modal.feature_5.description"}}</p>
                  </li>
                </ol>
  
                <Shared::Link
                  class="o--btn--lg o--btn--outline o--btn--block qa--learnMore_btn"
                  @href="https://later.com/linkinbio/"
                  @text={{t "shared_phrases.learn_more"}}
                />
                <Shared::Ui::Button
                  class="u--m__t qa--upgradeNow"
                  @additional="block"
                  @type="primary"
                  @size="large"
                  @text={{t "shared_phrases.upgrade_now"}}
                  @onClick={{fn this.goToPlansPage @isParentModalDirty @didLinkinbioPostChange @closeParentModal @post}}
                  data-test-id="linkin-bio-upgrade"
                />
              </modal.card-body>
            </div>
          </div>
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  
  */
  {
    "id": "nesVCDI0",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],null,[[\"@close\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card\"]],[[24,0,\"tOB--image__lib\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--col__6 u--col__push--6 cLB--contentWidth\"],[12],[1,\"\\n            \"],[8,[30,3,[\"card-header\"]],[[24,0,\"u--p__b__xs\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[14,0,\"o--modalHeader__title u--text--lg\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.title\"],null]],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,3,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.subtitle\"],null]],[13],[1,\"\\n              \"],[10,\"ol\"],[14,0,\"u--listUnstyle u--m__b__lg u--m__r__md\"],[12],[1,\"\\n                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[10,\"h3\"],[14,0,\"u--text--md u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_1.title\"],null]],[13],[1,\"\\n                  \"],[10,2],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_1.description\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n\\n\"],[41,[51,[30,4]],[[[1,\"                  \"],[10,\"li\"],[12],[1,\"\\n                    \"],[10,\"h3\"],[14,0,\"u--text--md u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_2.title\"],null]],[13],[1,\"\\n                    \"],[10,2],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_2.description\"],null]],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[10,\"h3\"],[14,0,\"u--text--md u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_3.title\"],null]],[13],[1,\"\\n                  \"],[10,2],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_3.description\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n\\n                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[10,\"h3\"],[14,0,\"u--text--md u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_4.title\"],null]],[13],[1,\"\\n                  \"],[10,2],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_4.description\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n\\n                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[10,\"h3\"],[14,0,\"u--text--md u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_5.title\"],null]],[13],[1,\"\\n                  \"],[10,2],[12],[1,[28,[35,2],[\"linkinbio.upgrade_modal.feature_5.description\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[8,[39,4],[[24,0,\"o--btn--lg o--btn--outline o--btn--block qa--learnMore_btn\"]],[[\"@href\",\"@text\"],[\"https://later.com/linkinbio/\",[28,[37,2],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n              \"],[8,[39,5],[[24,0,\"u--m__t qa--upgradeNow\"],[24,\"data-test-id\",\"linkin-bio-upgrade\"]],[[\"@additional\",\"@type\",\"@size\",\"@text\",\"@onClick\"],[\"block\",\"primary\",\"large\",[28,[37,2],[\"shared_phrases.upgrade_now\"],null],[28,[37,6],[[30,0,[\"goToPlansPage\"]],[30,5],[30,6],[30,7],[30,8]],null]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[]],null]],[\"@isVisible\",\"@closeModal\",\"modal\",\"@isOnLegacyPlan\",\"@isParentModalDirty\",\"@didLinkinbioPostChange\",\"@closeParentModal\",\"@post\"],false,[\"if\",\"shared/modal\",\"t\",\"unless\",\"shared/link\",\"shared/ui/button\",\"fn\"]]",
    "moduleName": "shared/components/shared/linkinbio/modal/upgrade.hbs",
    "isStrictMode": false
  });

  let UpgradeComponent = (_class = class UpgradeComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "errors", _descriptor6, this);
    }

    async goToPlansPage(isParentModalDirty, didLinkinbioPostChange, closeParentModal, post) {
      this._trackClickedUpgrade();

      if (isParentModalDirty) {
        this.showConfirmationModal(closeParentModal, post);
      } else if (didLinkinbioPostChange && (await didLinkinbioPostChange())) {
        this.showConfirmationModal(closeParentModal, post);
      } else {
        this.subscriptions.upgrade('linkinbioStandard', 'linkinbio upgrade modal');
      }
    }

    async showConfirmationModal(closeParentModal, post) {
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
        description: this.intl.t('shared_phrases.changes_not_saved'),
        confirmButton: this.intl.t('shared_words.leave')
      });

      if (!didConfirm) {
        return;
      }

      try {
        closeParentModal();
        post.rollbackAttributes();
        post.set('previewDataUrl', null);
        post.get('postMediaItems').forEach(pmi => {
          if (pmi.get('hasDirtyAttributes')) {
            pmi.rollbackAttributes();
          }

          pmi.set('previewDataUrl', null);
        });
        this.subscriptions.upgrade('linkinbioStandard', 'linkinbio upgrade modal');
      } catch (error) {
        this.errors.log(error);
      }
    }

    _trackClickedUpgrade() {
      this.segment.track('clicked-upgrade-button', {
        button_location: 'linkinbio upgrade modal',
        source_page: '/linkinbio/upgrade'
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "goToPlansPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPlansPage"), _class.prototype)), _class);
  _exports.default = UpgradeComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeComponent);
});